<template>
	<div class="login-modal">
		<b-modal :id="modalId" centered hide-header hide-footer @visible="handleCloseModal">
			<h2 class="login-modal__title font-size-24 font-sanpro-semibold primary-color-txt text-center">Đăng nhập</h2>
			<p class="login-modal__desc secondary-color-txt font-sanpro-light">
				Tính năng hoặc học liệu này yêu cầu bạn đăng ký/ đăng nhập và nhập mã sách để kích hoạt và sử dụng.
			</p>
			<a href="javascript:;" class="login-modal__readmore primary-color font-sanpro-semibold display-table" @click="openReadMoreBookCode">Tìm hiểu mã kích hoạt</a>
			<div class="login-moal__form">
				<b-form @submit.prevent="handleLogin">
					<div class="login-modal__form__item display-block">
						<b-form-input 
							id="input-username" 
							v-model="form.username" 
							type="text" 
							placeholder="Email đăng nhập" 
							autocomplete="off"
							class="form-control display-flex-center form-30h form-bg-gray-light border-rd-20 font-sanpro-light" 
							required 
						/>
						<span 
							class="error display-block color-err font-size-14 text-left" 
							v-if="!$v.form.username.required && submitted"
						>
							Vui lòng điền email
						</span>
						<span 
							class="error display-block color-err font-size-14 text-left" 
							v-if="!$v.form.username.email && submitted"
						>
							Địng dạng email không đúng
						</span>
						<span 
							class="error display-block color-err font-size-14 text-left" 
							v-if="loginFailed"
						>
							Tài khoản hoặc mật khẩu không đúng
						</span>
					</div>
					<div class="login-modal__form__item display-block position-rel">
						<b-form-input 
							id="input-password" 
							v-model="form.password"
							:type="passwordFieldType"
							required 
							placeholder="Mật khẩu" 
							autocomplete="off" 
							class="form-control display-flex-center form-30h form-bg-gray-light border-rd-20 font-sanpro-light" 
						/>
						<div class="icon-switch"  v-if="form.password !== ''">
							<i class="fa" :class="{'fa-eye': statusEye, 'fa-eye-slash': !statusEye}" @click="switchPassword"></i>
						</div>
						<span 
							class="error display-block color-err font-size-14 text-left" 
							v-if="!$v.form.password.required && submitted"
						>
							Vui lòng điền mật khẩu
						</span>
					</div>
					<div class="login-modal__form__action">
						<button 
							type="submit" 
							class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold full-width display-flex-center justify-content-center line-height-1" 
							:disabled="isLoading" 
							@click="handleLogin"
						>
							Đăng nhập
						</button>                  
					</div>
				</b-form>
				<a
          href="javascript:;" 
					@click="directForgotPassword"
					class="login-modal__forgot display-block primary-color txt-underline forgot-pass-btn text-center font-sanpro-light display-block" 
				>
					Quên mật khẩu?
				</a>
				<p class="login-modal__register text-center secondary-color-txt font-sanpro-light">
					Bạn chưa có tài khoản?
					<a href="javascript:;" class="primary-color text-underline forgot-pass-btn font-sanpro-light" @click="handleLogout">Đăng ký ngay</a>
				</p>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';
	import { ID_MODAL_LOGIN } from '@/store/auth/constants';
	import { required, email } from 'vuelidate/lib/validators';
	import { login } from '@/store/auth/api';

	export default {
		name: 'LoginPopup',
		data () {
			return {
				modalId: ID_MODAL_LOGIN,
				loginFailed: false,
				isLoading: false,
				submitted: false,
				form: {
					username: '',
					password: ''
				},
				statusEye:false,
				password: '',
				passwordFieldType: 'password',
			}
		},
		components: {},
		computed: {
			...mapState('auth', ['isOpenLoginForm']),
		},
		validations(){
			return {
				form:{
					username: {
						required,
						email
					},
					password:{
						required
					}
				}
			}
		},
		watch: {
			isOpenLoginForm(newVal) {
				if(newVal) {
					this.$bvModal.show(ID_MODAL_LOGIN);
				} else {
					this.$bvModal.hide(ID_MODAL_LOGIN);
				}
			}
		},
		mounted() {
			this.$root.$on('bv::modal::hide', () => {
		      this.setToggleLoginForm(false);
		    })
		},
		methods: {
			...mapActions(`auth`, ['authLogin', 'authLogout', 'setLoginPopupData', 'setToggleLoginForm']),
			...mapActions('common', ['setToggleGuideActiveBook']),

			openModal() {
				this.$bvModal.show(ID_MODAL_LOGIN);
			},

			openReadMoreBookCode() {
				this.setToggleGuideActiveBook(true);
			},
			switchPassword(){
				this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
				this.statusEye = !this.statusEye;
			},
			//load lại trang 
			reLoadPage() {
				location.reload()
			},

			handleLogin() {
				let self = this;
				self.loginFailed = false;
				self.submitted = true;
				// self.isLoading = true;

				self.$v.$touch();
				if (self.$v.$invalid) {
					return;
				}

				login(self.form.username, self.form.password).then(res => {
					if(res) {
						self.setToggleLoginForm(false);
						self.setLoginPopupData(res)
						self.$bvModal.hide(ID_MODAL_LOGIN);
						//load lại trang sau khi đăng nhập từ tài khoản trải nghiệm
						this.reLoadPage()
					}
				}).finally(() => {
					this.submitted = false;
					this.isLoading = false;
				});
				// this.isLoading = false;
			},

			handleCloseModal() {
				this.setToggleLoginForm(false);
			},

			handleLogout() {
				// this.authLogout();
				this.$bvModal.hide(ID_MODAL_LOGIN);
				this.$bvModal.show('modalRegister');
			},

      directForgotPassword () {
        this.setToggleLoginForm(false)
        this.$router.push({ name: 'forgot-password' })
      }
		}
	}
</script>

<style lang="scss">
	.icon-switch{
		position: absolute;
		top: 7px;
		right: 10px;
		i{
		color: #40505E;
		font-size: 14px;
		opacity: .5;
		}
	}
	#modal_login {
		.modal-content {
			border: 0;
			max-width: 365px;
    		margin: auto;
    		border-radius: 20px;

    		@media screen and ( max-width: 575px ) {
    			max-width: 90%;
    		}
		}

		.modal-body {
			background: #fff;
			padding: 15px;
			border-radius: 15px;
		}

		.forgot-pass-btn {
			padding: 0;
		}

		.error {
			margin-top: 7px;
		}

		.login-modal {

			&__title, &__readmore, &__forgot {
				margin-bottom: 15px;
			}

			&__desc {
				margin-bottom: 10px;
			}

			&__form {
				&__item {
					margin-bottom: 15px;
				}

				&__action {
					margin: 10px 0 18px;
				}
			}
		}
	}
</style>